export enum ColumnType {
    TEXT = 'TEXT',
    MAIL = 'MAIL',
    LINK = 'LINK',
    DATE = 'DATE'
}
